/**
 * Somatus Hybrid Scheduler API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AppointmentNoteRequest } from '../model/appointmentNoteRequest';
import { AppointmentNoteResponse } from '../model/appointmentNoteResponse';
import { AppointmentResendInviteRequestModel } from '../model/appointmentResendInviteRequestModel';
import { UpdateAppointmentContactInfoRequest } from '../model/updateAppointmentContactInfoRequest';
import { ViewAppointment } from '../model/viewAppointment';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AppointmentManagementService {

    protected basePath = 'http://localhost:5001/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public appointmentManagementAppointmentNote(body: AppointmentNoteRequest, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public appointmentManagementAppointmentNote(body: AppointmentNoteRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public appointmentManagementAppointmentNote(body: AppointmentNoteRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public appointmentManagementAppointmentNote(body: AppointmentNoteRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling appointmentManagementAppointmentNote.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<boolean>('post',`${this.basePath}/api/AppointmentManagement/note`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public appointmentManagementAppointmentNotification(body: UpdateAppointmentContactInfoRequest, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public appointmentManagementAppointmentNotification(body: UpdateAppointmentContactInfoRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public appointmentManagementAppointmentNotification(body: UpdateAppointmentContactInfoRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public appointmentManagementAppointmentNotification(body: UpdateAppointmentContactInfoRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling appointmentManagementAppointmentNotification.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<boolean>('post',`${this.basePath}/api/AppointmentManagement/notification`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param appointmentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public appointmentManagementGetAppointmentHistory(appointmentId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ViewAppointment>>;
    public appointmentManagementGetAppointmentHistory(appointmentId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ViewAppointment>>>;
    public appointmentManagementGetAppointmentHistory(appointmentId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ViewAppointment>>>;
    public appointmentManagementGetAppointmentHistory(appointmentId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (appointmentId === null || appointmentId === undefined) {
            throw new Error('Required parameter appointmentId was null or undefined when calling appointmentManagementGetAppointmentHistory.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ViewAppointment>>('get',`${this.basePath}/api/AppointmentManagement/history/${encodeURIComponent(String(appointmentId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public appointmentManagementGetAppointmentNotes(id: number, observe?: 'body', reportProgress?: boolean): Observable<Array<AppointmentNoteResponse>>;
    public appointmentManagementGetAppointmentNotes(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AppointmentNoteResponse>>>;
    public appointmentManagementGetAppointmentNotes(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AppointmentNoteResponse>>>;
    public appointmentManagementGetAppointmentNotes(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling appointmentManagementGetAppointmentNotes.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<AppointmentNoteResponse>>('get',`${this.basePath}/api/AppointmentManagement/notes/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param meetingid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public appointmentManagementGetMeetingRecording(meetingid: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public appointmentManagementGetMeetingRecording(meetingid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public appointmentManagementGetMeetingRecording(meetingid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public appointmentManagementGetMeetingRecording(meetingid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (meetingid === null || meetingid === undefined) {
            throw new Error('Required parameter meetingid was null or undefined when calling appointmentManagementGetMeetingRecording.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<string>('get',`${this.basePath}/api/AppointmentManagement/GetRecording/${encodeURIComponent(String(meetingid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public appointmentManagementResendInvite(body: AppointmentResendInviteRequestModel, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public appointmentManagementResendInvite(body: AppointmentResendInviteRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public appointmentManagementResendInvite(body: AppointmentResendInviteRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public appointmentManagementResendInvite(body: AppointmentResendInviteRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling appointmentManagementResendInvite.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<boolean>('post',`${this.basePath}/api/AppointmentManagement/resendinvite`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
